import { NavItems } from 'src/layouts/AuthenticatedLayout/components/Nav';

export default (propertyGroupId: string): NavItems => {
  return [
    {
      exact: true,
      icon: 'home',
      name: 'Home',
      to: `/property-groups/${propertyGroupId}`,
    },
    {
      icon: 'people',
      name: 'Users',
      to: `/property-groups/${propertyGroupId}/users`,
    },
  ];
};
